import React from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { NotesBoard, type NotesBoardMetaField } from '@/components/NotesBoard';

const STATUS_OPTIONS = ['planning', 'active', 'paused', 'done'];

const META_FIELDS: NotesBoardMetaField[] = [
  {
    key: 'campus',
    label: 'Campus',
    placeholder: 'e.g. Michigan',
    suggestions: ['Michigan', 'Tulane'],
  },
];

export function CampusGrowthScreen() {
  return (
    <div className="admin-page max-w-3xl mx-auto">
      <PageHeader
        title="Campus Growth"
        subtitle="Strategy and metrics per target campus, grouped so each school's notes read together at a glance."
      />
      <NotesBoard
        page="campus_growth"
        statusOptions={STATUS_OPTIONS}
        metadataFields={META_FIELDS}
        groupByField="campus"
        newButtonLabel="Add campus note"
        emptyTitle="No campus notes yet"
        emptyHint="Add a strategy or metrics note for a campus above — pick Michigan/Tulane or type a new one."
      />
    </div>
  );
}
